import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ModalConfig {
  id: string;
  title: string;
  size: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'status';
  content: any;
  data?: any;
  closable?: boolean;
  backdropClose?: boolean;
  hasFooterContent?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private activeModalsSubject = new BehaviorSubject<ModalConfig[]>([]);
  public activeModals$: Observable<ModalConfig[]> = this.activeModalsSubject.asObservable();

  private modalDataSubject = new BehaviorSubject<any>(null);
  public modalData$: Observable<any> = this.modalDataSubject.asObservable();

  constructor() {}

  openModal(config: ModalConfig): void {
    const currentModals = this.activeModalsSubject.value;
    const existingModalIndex = currentModals.findIndex(modal => modal.id === config.id);
    
    if (existingModalIndex !== -1) {
      // Update existing modal
      currentModals[existingModalIndex] = config;
    } else {
      // Add new modal
      currentModals.push(config);
    }
    
    this.activeModalsSubject.next([...currentModals]);
    this.modalDataSubject.next(config.data);
  }

  closeModal(modalId: string): void {
    const currentModals = this.activeModalsSubject.value;
    const filteredModals = currentModals.filter(modal => modal.id !== modalId);
    this.activeModalsSubject.next(filteredModals);
    
    if (filteredModals.length === 0) {
      this.modalDataSubject.next(null);
    }
  }

  closeAllModals(): void {
    this.activeModalsSubject.next([]);
    this.modalDataSubject.next(null);
  }

  isModalOpen(modalId: string): boolean {
    return this.activeModalsSubject.value.some(modal => modal.id === modalId);
  }

  getActiveModals(): ModalConfig[] {
    return this.activeModalsSubject.value;
  }
} 
